
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

//Usage 
import UsagePage from './features/account/components/UsagePage';

// Layouts
import MainLayout from './components/layout/MainLayout';

// Auth Components
import LoginForm from './features/auth/components/LoginForm';
import RegisterForm from './features/auth/components/RegisterForm';
import ForgotPasswordForm from './features/auth/components/ForgotPasswordForm';
import ResetPasswordForm from './features/auth/components/ResetPasswordForm';

// Account Components
import Dashboard from './features/account/components/Dashboard';
import ApiKeysList from './features/account/components/ApiKeysList';
import UserProfileForm from './features/account/components/UserProfileForm';

// Payment Components
import PaymentPage from './features/payment/components/PaymentPage';
import PaymentHistoryList from './features/payment/components/PaymentHistoryList';

// Documentation Component (placeholder)
import DocumentationHome from './features/documentation/components/DocumentationHome';

// Home and Error Components
import HomePage from './components/common/HomePage';
import NotFoundPage from './components/common/NotFoundPage';

// Static Pages
import AboutPage from './components/common/AboutPage';
import ContactPage from './components/common/ContactPage';
import TermsPage from './components/common/TermsPage';
import PrivacyPage from './components/common/PrivacyPage';

// Protected Route Wrapper
import ProtectedRoute from './components/common/ProtectedRoute';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<MainLayout maxWidth={false}><HomePage /></MainLayout>} />
      
      {/* Auth Routes */}
      <Route path="/login" element={
        <MainLayout maxWidth="xs">
          <LoginForm />
        </MainLayout>
      } />
      
      <Route path="/register" element={
        <MainLayout maxWidth="sm">
          <RegisterForm />
        </MainLayout>
      } />
      
      <Route path="/forgot-password" element={
        <MainLayout maxWidth="xs">
          <ForgotPasswordForm />
        </MainLayout>
      } />
      
      <Route path="/reset-password/:token" element={
        <MainLayout maxWidth="xs">
          <ResetPasswordForm />
        </MainLayout>
      } />
      
      {/* Protected Routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <MainLayout>
            <Dashboard />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/api-keys" element={
        <ProtectedRoute>
          <MainLayout>
            <ApiKeysList />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/profile" element={
        <ProtectedRoute>
          <MainLayout>
            <UserProfileForm />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/payment" element={
        <ProtectedRoute>
          <MainLayout>
            <PaymentPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/payments-history" element={
        <ProtectedRoute>
          <MainLayout>
            <PaymentHistoryList />
          </MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/usage" element={
        <ProtectedRoute>
          <MainLayout>
            <UsagePage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      {/* Documentation Routes */}
      <Route path="/docs" element={
        <MainLayout>
          <DocumentationHome />
        </MainLayout>
      } />

      <Route path="/docs/:section" element={
        <MainLayout>
          <DocumentationHome />
        </MainLayout>
      } />

      {/* Static Pages */}
      <Route path="/about" element={
        <MainLayout>
          <AboutPage />
        </MainLayout>
      } />

      <Route path="/contact" element={
        <MainLayout>
          <ContactPage />
        </MainLayout>
      } />

      <Route path="/terms" element={
        <MainLayout>
          <TermsPage />
        </MainLayout>
      } />

      <Route path="/privacy" element={
        <MainLayout>
          <PrivacyPage />
        </MainLayout>
      } />

      {/* Error/Not Found */}
      <Route path="/404" element={
        <MainLayout>
          <NotFoundPage />
        </MainLayout>
      } />

      {/* Redirect any unmatched routes to 404 */}
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};

export default AppRoutes;
